"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStore = void 0;
const loader_1 = require("../../loader");
const check_1 = require("../check");
const ctx_1 = require("../ctx");
const evaluate_1 = require("../evaluate");
const mod_1 = require("../mod");
const syntax_1 = require("../syntax");
class GlobalStore {
    constructor() {
        this.claimed = new Map();
        this.typedValues = new Map();
        this.mod = new mod_1.Mod({ loader: new loader_1.Loader(), url: new URL("globals://") });
    }
    mount(mod) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const [name, { type, value }] of this.typedValues.entries()) {
                mod.ctx = (0, ctx_1.CtxFulfilled)(name, type, value, mod.ctx);
            }
        });
    }
    claim(name, type) {
        if (typeof type === "string") {
            const exp = (0, syntax_1.parseExp)(type);
            const core = (0, check_1.checkType)(this.mod, this.mod.ctx, exp);
            this.claimed.set(name, (0, evaluate_1.evaluate)(this.mod.env, core));
        }
        else {
            this.claimed.set(name, type);
        }
    }
    define(name, value) {
        const type = this.claimed.get(name);
        if (type === undefined) {
            throw new Error(`unclaimed: ${name}`);
        }
        if (typeof value === "string") {
            const exp = (0, syntax_1.parseExp)(value);
            const core = (0, check_1.check)(this.mod, this.mod.ctx, exp, type);
            value = (0, evaluate_1.evaluate)(this.mod.env, core);
        }
        this.typedValues.set(name, { type, value });
        this.mod.define(name, type, value);
    }
}
exports.GlobalStore = GlobalStore;
//# sourceMappingURL=GlobalStore.js.map